<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.499167 9.70711L7.3725 2.83377L9.16539 4.62667L2.29206 11.5H0.499167V9.70711ZM11.4523 2.33978L10.5858 3.20623L8.79294 1.41333L9.65939 0.546887C9.69068 0.51559 9.72949 0.5 9.7725 0.5C9.82484 0.5 9.86062 0.515225 9.89228 0.546887L11.4523 2.10689C11.517 2.17162 11.517 2.27504 11.4523 2.33978Z"
      :stroke="color"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#0043CE'
    },
    width: {
      type: String,
      default: '21'
    },
    height: {
      type: String,
      default: '21'
    }
  }
}
</script>
